import React from 'react';
import { Typography, Box, Container, Grid, Stack, Link } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { IMAGES, PHONE_DISPLAY, PHONE_HREF } from '../theme';
export function Footer() {
  return <Box component="footer" sx={{
    bgcolor: '#0F2037',
    color: 'white',
    py: 6
  }} data-id="element-14">
      <Container maxWidth="lg" data-id="element-15">
        <Grid container spacing={4} justifyContent="space-between" data-id="element-16">
          <Grid item xs={12} md={5} data-id="element-17">
            <Box component="img" src={IMAGES.logo} alt="The Patio Cover Company" sx={{
            height: 60,
            objectFit: 'contain',
            mb: 2,
            filter: 'brightness(0) invert(1)'
          }} data-id="element-18" />
            <Typography variant="body2" sx={{
            opacity: 0.7,
            maxWidth: 360
          }} data-id="element-19">
              Premium custom patio covers and pergolas serving Brentwood, CA and
              surrounding East Bay communities.
            </Typography>
          </Grid>

          <Grid item xs={12} md={4} data-id="element-20">
            <Typography variant="subtitle1" fontWeight="bold" sx={{
            mb: 2
          }} data-id="element-21">
              Get In Touch
            </Typography>
            <Stack spacing={1.5} data-id="element-22">
              <Stack direction="row" spacing={1.5} alignItems="center" data-id="element-23">
                <PhoneIcon color="secondary" fontSize="small" data-id="element-24" />
                <Link href={PHONE_HREF} underline="hover" sx={{
                color: 'white',
                opacity: 0.85
              }} data-id="element-25">
                  {PHONE_DISPLAY}
                </Link>
              </Stack>
              <Stack direction="row" spacing={1.5} alignItems="center" data-id="element-26">
                <LocationOnIcon color="secondary" fontSize="small" data-id="element-27" />
                <Typography variant="body2" sx={{
                opacity: 0.85
              }} data-id="element-28">
                  Brentwood, CA & Surrounding Areas
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Box sx={{
        mt: 5,
        pt: 3,
        borderTop: '1px solid rgba(255,255,255,0.1)'
      }} data-id="element-29">
          <Typography variant="body2" sx={{
          opacity: 0.6
        }} data-id="element-30">
            &copy; {new Date().getFullYear()} The Patio Cover Company. All
            rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>;
}